class Navbar {

  constructor (el) {
    this.$el = el
    this.$links = this.$el.find('.js-navbar-link')
    this.$menuContainer = this.$el.find('.js-navbar-menu-container')
    this.$menuWrapper = this.$el.find('.js-navbar-menu-wrapper')
    this.$submenu = this.$el.find('.js-navbar-submenu')
    this.$submenuItem = this.$el.find('.js-navbar-submenu-item')
    this.$submenuBackButton = this.$el.find('.js-navbar-submenu-back')
    this.$userButton = this.$el.find('.js-navbar-show-user-dropdown')
    this.$userDropdown = this.$el.find('.js-navbar-user-dropdown')
    this.$burger = this.$el.find('.js-navbar-burger')
    this.$controls = this.$el.find('.js-navbar-controls')
    this.$spBtn = this.$el.find('.js-navbar-sp-btn')
    this.$spfButtons = this.$el.find('.js-navbar-spf-btn')
    this.$spfDefaultBtn = this.$el.find('[data-default-fs]')
    this.$spfIncreaseBtn = this.$el.find('[data-increase-fs]')
    this.isFirstHover = true
    this.mouseoverTimeout = null
    this.mouseleaveTimeout = null
    this.closeSubmenuTimeout = null
    this.activeEl = null
    this.isMobile = false

    this.initDefault();
  }

  initDefault () {
    this.initEvents()
    this.checkMobile()
    this.setLinksEvent()
  }

  initEvents () {
    this.$submenu.on( 'mouseover', e => this.clearMouseleaveTimeout())
    this.$submenu.on( 'mouseleave', e => this.closeSubmenu())
    this.$userButton.on( 'click', e => this.openUserDropdown(e))
    this.$burger.on( 'click', e => this.onBurgerClick(e) )
    this.$submenuBackButton.on( 'click', e => this.closeMobileSubmenu() )
    this.$spBtn.on('click', e => this.toggleControls(e))
    this.$spfDefaultBtn.on('click', e => this.setDefaultFS(e))
    this.$spfIncreaseBtn.on('click', e => this.setIncreasedFS(e))
    $(document).on( 'click', e => this.onDocumentClick(e) )
    $(window).on( 'resize', e => this.onResize() )
    window.addEventListener('scroll', e => this.onWheel(e) )
  }

  toggleControls (e) {
    e.preventDefault()
    this.setContrastTheme()
  }
  
  setContrastTheme () {
    const localStorage = window.localStorage
    document.documentElement.classList.toggle('contrast-theme')
    if (document.documentElement.classList.contains('contrast-theme')) {
      localStorage.setItem('tc_contrast_theme', 'true')
    } else {
      localStorage.setItem('tc_contrast_theme', 'false')
      localStorage.setItem('tc_increased_fs', 'false')
      document.documentElement.classList.remove('increased-fs')
    }
  }

  setDefaultFS (e) {
    e.preventDefault()
    const localStorage = window.localStorage
    document.documentElement.classList.remove('increased-fs')
    localStorage.setItem('tc_increased_fs', 'false')
  }
  
  setIncreasedFS (e) {
    e.preventDefault()
    const localStorage = window.localStorage
    document.documentElement.classList.add('increased-fs')
    localStorage.setItem('tc_increased_fs', 'true')
  }

  onWheel () {
    this.windowCoords = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.windowCoords > 0 ? this.$el.addClass('active') : this.$el.removeClass('active')
  }

  onResize () {
    this.checkMobile()
    this.setLinksEvent()
    this.clearMouseleaveTimeout()
    this.closeSubmenu(1)
    if ( !this.isMobile ) {
      this.closeMobileMenu()
      this.resetStyles()
    }
  }

  onBurgerClick (e) {
    e.preventDefault()
    if ( this.$burger.hasClass('active') ) {
      this.$burger.removeClass('active')
      this.closeMobileMenu()
    } else {
      this.$burger.addClass('active')
      this.openMobileMenu()
    }
  }

  resetStyles () {
    this.$menuWrapper.css({ 'transform' : 'none' })
  }

  checkMobile () {
    window.innerWidth > 1023 ? this.isMobile = false : this.isMobile = true
  }

  setLinksEvent () {
    if ( this.isMobile ) {
      this.$links.off()
      this.$links.on( 'touchstart click', e => this.onLinkHover(e))
    } else {
      this.$links.off()
      this.$links.on( 'mouseover touchstart', e => this.onLinkHover(e))
      this.$links.on( 'mouseleave', e => this.closeSubmenu())
    }
  }

  onDocumentClick (e) {
    if ( !$('.js-navbar-show-user-dropdown').is(e.target) && $('.js-navbar-show-user-dropdown').has(e.target).length === 0 ) {
      this.closeUserDropdown()
    }
    if ( !$('.js-navbar-menu-container').is(e.target) && $('.js-navbar-menu-container').has(e.target).length === 0 && !$('.js-navbar-burger').is(e.target) && $('.js-navbar-burger').has(e.target).length === 0 ) {
      this.closeMobileMenu()
    }
    if ( !$('.navbar__menu').is(e.target) && $('.navbar__menu').has(e.target).length === 0 && !$('.js-navbar-burger').is(e.target)) {
      this.closeSubmenu()
    }
  }

  openUserDropdown (e) {
    e.preventDefault()
    this.$userButton.toggleClass('active')
    this.$userDropdown.toggleClass('active')
  }
  
  closeUserDropdown () {
    this.$userButton.removeClass('active')
    this.$userDropdown.removeClass('active')
  }

  onLinkHover (e) {
    e.preventDefault()
    e.stopPropagation()
    const index = this.$links.index(e.currentTarget)
    this.activeEl = this.$links.eq(index)
    this.isMobile ? this.openMobileSubmenu(index) : this.openSubmenu(index)
  }

  openMobileMenu () {
    this.$menuContainer.addClass('active')
    document.body.classList.add('block-scroll')
  }

  closeMobileMenu () {
    this.$burger.removeClass('active')
    this.$menuContainer.removeClass('active')
    this.$menuWrapper.css({ 'transform' : 'translate3d(0, 0, 0)' })
    if ( !this.isMobile ) {
      this.resetStyles()
    }
    document.body.classList.remove('block-scroll')
  }

  closeSubmenu ( ms ) {
    let delay = ms || 600
    this.mouseleaveTimeout = setTimeout( () => {
      this.$links.removeClass('active')
      this.$submenu.removeClass('active')
      this.isFirstHover = true
      this.$submenu.css({ 
        'transition' : 'transform 0ms ease, opacity 300ms ease',
        'transform' : 'translate3d(0, 0, 0)'
      })
    }, delay)
  }

  openSubmenu ( index ) {
    this.$links.removeClass('active')
    this.activeEl.addClass('active')
    this.$submenuItem.fadeOut(0)
    this.$submenuItem.eq(index).fadeIn(0)
    this.clearMouseleaveTimeout()
    if ( this.isFirstHover ) {
      this.mouseoverTimeout = setTimeout( () => {
        this.$submenu.css({ 'transition' : 'transform 300ms ease, opacity 300ms ease' })
        this.isFirstHover = false
      }, 100 )
    }
    this.$submenu.css({ 
      'transform' : 'translate3d(' + this.$links.eq(index).offset().left + 'px, 0, 0)', 
    })
    this.$submenu.addClass('active')
  }

  openMobileSubmenu (index) {
    this.$submenuItem.fadeOut(0)
    this.$submenuItem.eq(index).fadeIn(0)
    this.$menuWrapper.css({ 'transform' : 'translate3d(-100%, 0, 0)' })
  }
  
  closeMobileSubmenu () {
    this.$submenuItem.delay(300).fadeOut(0)
    this.$menuWrapper.css({ 'transform' : 'translate3d(0, 0, 0)' })
  }

  clearMouseleaveTimeout () {
    clearTimeout(this.mouseleaveTimeout)
  }

}

$( function () {

  const $el = $('.js-navbar');

  if ( $el.length ) {
    new Navbar($el)
  }

})
